/**
 * jug.ts — Categoría "Juguetería" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_jug",
  skuPrefix: "JUG",
  categoria: "Juguetería",
} as const;

export const cat_jug_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Lego Creator 3-en-1",
    marca: "Lego",
    modelo: "Creator 31058",
    origen: "Dinamarca",
    costo: 85000,
    precio: 129000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "caja",
    ubicacionFisica: "Estante J1",
    proveedor: "Lego Colombia",
    material: "Plástico ABS",
    descripcionLarga:
      "Set LEGO Creator 3-en-1 174 piezas: dinosaurio T-Rex, Triceratops o Pterodáctilo. Para mayores 7 años.",
    especificaciones: [
      { clave: "Piezas", valor: "174" },
      { clave: "Edad", valor: "7+" },
    ],
    imageKeywords: ["lego-creator", "lego-dinosaur", "lego-set"],
    color: "bg-red-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Barbie Fashionista",
    marca: "Barbie",
    modelo: "Fashionistas #200",
    origen: "China",
    costo: 48500,
    precio: 74900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante J2",
    proveedor: "Mattel Colombia",
    material: "Plástico ABS",
    colorProducto: "Multicolor",
    descripcionLarga:
      "Muñeca Barbie Fashionistas con outfit moderno, accesorios y cepillo. Peinado y vestido personalizables.",
    especificaciones: [
      { clave: "Altura", valor: "30cm" },
      { clave: "Edad", valor: "3+" },
    ],
    imageKeywords: ["barbie-doll", "fashion-doll", "mattel"],
    color: "bg-pink-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Hot Wheels 5 Pack",
    marca: "Hot Wheels",
    origen: "Tailandia",
    costo: 38500,
    precio: 59900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "paquete",
    ubicacionFisica: "Estante J3",
    proveedor: "Mattel Colombia",
    material: "Metal y plástico",
    descripcionLarga:
      "Pack 5 carritos Hot Wheels escala 1:64. Surtido variado colores y diseños, compatibles pista Hot Wheels.",
    especificaciones: [
      { clave: "Unidades", valor: "5" },
      { clave: "Escala", valor: "1:64" },
    ],
    imageKeywords: ["hot-wheels", "toy-cars", "diecast-cars"],
    color: "bg-orange-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Puzzle 1000 Piezas",
    marca: "Ravensburger",
    modelo: "Vista París",
    origen: "Alemania",
    costo: 65000,
    precio: 99900,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "caja",
    ubicacionFisica: "Estante J4",
    proveedor: "Ravensburger Colombia",
    material: "Cartón",
    descripcionLarga:
      "Rompecabezas 1000 piezas vista panorámica París. Cartón grueso premium, póster de referencia incluido.",
    especificaciones: [
      { clave: "Piezas", valor: "1000" },
      { clave: "Tamaño", valor: "70x50cm" },
    ],
    imageKeywords: ["puzzle", "jigsaw-puzzle", "ravensburger"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Balón de Fútbol No.5",
    marca: "Golty",
    modelo: "Trueno",
    origen: "Colombia",
    costo: 45000,
    precio: 69900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "unidad",
    ubicacionFisica: "Estante J5",
    proveedor: "Golty S.A.",
    material: "Cuero sintético",
    colorProducto: "Blanco/negro",
    descripcionLarga:
      "Balón oficial Golty Trueno talla 5, 32 paneles cosidos a mano, cámara butilo. Ideal partidos y entrenamientos.",
    especificaciones: [
      { clave: "Talla", valor: "5" },
      { clave: "Paneles", valor: "32 cosidos" },
    ],
    imageKeywords: ["soccer-ball", "football", "golty-ball"],
    color: "bg-white",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Peluche Oso 60cm",
    marca: "TeddyLand",
    origen: "China",
    costo: 38500,
    precio: 59900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante J6",
    proveedor: "TeddyLand Importaciones",
    material: "Felpa y fibra sintética",
    colorProducto: "Marrón claro",
    descripcionLarga:
      "Peluche oso de felpa ultra suave 60cm, relleno hipoalergúnico. Corbatón rojo removible. Lavable a mano.",
    especificaciones: [
      { clave: "Altura", valor: "60cm" },
      { clave: "Material", valor: "Felpa premium" },
    ],
    imageKeywords: ["teddy-bear", "plush-toy", "stuffed-animal"],
    color: "bg-amber-300",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Carro Radio Control 4x4",
    marca: "Kidztech",
    modelo: "Buggy RC",
    origen: "China",
    costo: 125000,
    precio: 189000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Estante J7",
    proveedor: "Kidztech Colombia",
    garantia: "6 meses",
    material: "Plástico ABS y metal",
    colorProducto: "Rojo",
    descripcionLarga:
      "Buggy RC 4x4 escala 1:10, velocidad 25km/h, alcance 50m. Baterías recargables incluidas, control 2.4GHz.",
    especificaciones: [
      { clave: "Escala", valor: "1:10" },
      { clave: "Autonomía", valor: "20 min" },
    ],
    imageKeywords: ["rc-car", "remote-control-car", "toy-vehicle"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Monopoly Clásico",
    marca: "Hasbro",
    modelo: "Monopoly Classic",
    origen: "EE.UU.",
    costo: 75000,
    precio: 114900,
    stock: 22,
    stockMinimo: 6,
    stockMaximo: 44,
    unidad: "caja",
    ubicacionFisica: "Estante J4",
    proveedor: "Hasbro Colombia",
    material: "Cartón, plástico y papel",
    descripcionLarga:
      "Juego de mesa Monopoly clásico versión español. 2-6 jugadores, tablero, fichas metálicas, billetes y escrituras.",
    especificaciones: [
      { clave: "Jugadores", valor: "2-6" },
      { clave: "Edad", valor: "8+" },
    ],
    imageKeywords: ["monopoly", "board-game", "hasbro-games"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Patineta Skate Completa",
    marca: "Element",
    modelo: "Section",
    origen: "China",
    costo: 225000,
    precio: 349000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Estante J7",
    proveedor: "Element Colombia",
    material: "Madera maple + aluminio",
    dimensiones: "8.0 pulgadas",
    descripcionLarga:
      'Patineta completa Element 8.0" con tabla maple 7 capas, trucks aluminio 139mm y ruedas 52mm 99A.',
    especificaciones: [
      { clave: "Tamaño", valor: '8.0"' },
      { clave: "Ruedas", valor: "52mm 99A" },
    ],
    imageKeywords: ["skateboard", "skate-deck", "element-skate"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Bloques Construcción 100pzs",
    marca: "MegaBlocks",
    origen: "China",
    costo: 48500,
    precio: 74900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "caja",
    ubicacionFisica: "Estante J1",
    proveedor: "Mattel Colombia",
    material: "Plástico ABS",
    descripcionLarga:
      "Bolsa 100 bloques de construcción multicolor, compatibles con otras marcas. Desarrolla creatividad infantil.",
    especificaciones: [
      { clave: "Piezas", valor: "100" },
      { clave: "Edad", valor: "1-5 años" },
    ],
    imageKeywords: ["building-blocks", "mega-blocks", "kids-toys"],
    color: "bg-blue-500",
    shape: "square",
  }),
];
